import { TaxGuideResponse } from '@/api/tax-guide';
import { CalculationModalContext } from '@/state/ModalProvider';
import { useEffect } from 'react';

type Props = {
  content?: TaxGuideResponse;
  modalStatus: CalculationModalContext;
};
const useTaxCalculationPopup = (props: Props) => {
  const { content, modalStatus } = props;

  const { taxCalculationPopupList } = content?.data || {};

  useEffect(() => {
    if (!taxCalculationPopupList || taxCalculationPopupList.length === 0)
      return;

    const popupDiv = document.getElementById('showInformationPopup');
    if (popupDiv) popupDiv.onclick = null; // Clear previous click handlers to prevent memory leaks

    const handlePopupClick = () => {
      modalStatus.setModal(true);
      modalStatus.setModalValues(taxCalculationPopupList);
    };

    popupDiv?.addEventListener('click', handlePopupClick);

    // Cleanup function to remove the event listener
    return () => {
      popupDiv?.removeEventListener('click', handlePopupClick);
    };
  }, [taxCalculationPopupList, modalStatus]);
};

export default useTaxCalculationPopup;
